/** @format */

const VoucherActionTypes = {
  SET_VOUCHER_DATE: 'SET_VOUCHER_DATE',
  SET_VOUCHER_SELECTED_KEYS: 'SET_VOUCHER_SELECTED_KEYS',
  SET_VOUCHER_SELECTED_CUSTOMERS: 'SET_VOUCHER_SELECTED_CUSTOMERS',

  FETCH_VOUCHER_INV_SEG_KEY_START: 'FETCH_VOUCHER_INV_SEG_KEY_START',
  FETCH_VOUCHER_INV_SEG_KEY_SUCCESS: 'FETCH_VOUCHER_INV_SEG_KEY_SUCCESS',
  FETCH_VOUCHER_INV_SEG_KEY_FAILURE: 'FETCH_VOUCHER_INV_SEG_KEY_FAILURE',

  FETCH_VOUCHER_BATCH_CUSTOMERS_START: 'FETCH_VOUCHER_BATCH_CUSTOMERS_START',
  FETCH_VOUCHER_BATCH_CUSTOMERS_SUCCESS:
    'FETCH_VOUCHER_BATCH_CUSTOMERS_SUCCESS',
  FETCH_VOUCHER_BATCH_CUSTOMERS_FAILURE:
    'FETCH_VOUCHER_BATCH_CUSTOMERS_FAILURE',

  SEND_VOUCHER_EMAIL_START: 'SEND_VOUCHER_EMAIL_START',
  SEND_VOUCHER_EMAIL_SUCCESS: 'SEND_VOUCHER_EMAIL_SUCCESS',
  SEND_VOUCHER_EMAIL_FAILURE: 'SEND_VOUCHER_EMAIL_FAILURE',
};
export default VoucherActionTypes;
